module.exports = __webpack_public_path__ + "img/man_jump_crm_login_light_2-p-500.c4e3454b.jpeg";